import { Modal, Toast } from 'antd-mobile';

export const confirmInputTrueName = (defautValue?: string): Promise<string> =>
    new Promise((ro, rj) => {
        Modal.prompt(
            '输入姓名',
            '请输入您的真实姓名用于分期',
            [
                {
                    text: '取消',
                },
                {
                    text: '确定',
                    onPress: value =>
                        new Promise((resolve, reject) => {
                            if (!value) {
                                Toast.show('请输入您的真实姓名', 1.5, false);
                                reject();
                            } else {
                                resolve(value);
                                ro(value);
                            }
                        }),
                },
            ],
            'default',
            defautValue
        );
    });
